import React, { useRef } from "react";
import { Button, Form, Input, Radio, Select } from "antd";
import { EducacionFormal } from "../../../../models/JuradosModel/jurados.model";
import { InputTexto } from "../../../../components/Mascaras/InputTexto/InputTexto";
import { openNotification } from "../../../../utils/Notifactions";
import DocumentInput from "../../../../utils/DocumentInput";
import DateInput from "../../../../utils/DateInput";

type FormEducacionFormalProps = {
  educacionFormal: EducacionFormal;
  guardarFormulario: any;
  setEducacionFormal: Function;
  guardarArchivo: any;
  formRef: any;
  resetForm: any;
  isGraduado: boolean;
  handleGraduacion: any;
};

export const FormEducacionFormal = ({
  educacionFormal,
  guardarFormulario,
  setEducacionFormal,
  guardarArchivo,
  formRef,
  resetForm,
  isGraduado,
  handleGraduacion,
}: FormEducacionFormalProps) => {
  const fields = [
    { name: "nivel_educacion", value: educacionFormal.nivel_educacion },
    { name: "titulo", value: educacionFormal.titulo },
    {
      name: "institucion_educativa",
      value: educacionFormal.institucion_educativa,
    },
    { name: "ciudad", value: educacionFormal.ciudad },
    { name: "graduado", value: educacionFormal.graduado },
    { name: "fecha_graduacion", value: educacionFormal.fecha_graduacion },
    { name: "path_anexo", value: educacionFormal.path_anexo },
  ];

  const fileInputRef = useRef<any>();

  return (
      <Form
        ref={formRef}
        name="educacionFormalForm"
        size="large"
        fields={fields}
        onFinish={(values: any) => {
          if (values.path_anexo === "") {
            return openNotification({
              titulo: "Error",
              descripcion: "Falta adjuntar archivo",
              placement: "bottomRight",
            });
          }
          return guardarFormulario();
        }}
        onFieldsChange={(_, fields: any) => {
          let infoupdate: any = { ...educacionFormal };
          for (const i in fields) {
            infoupdate[fields[i].name] = fields[i].value;
          }
          setEducacionFormal(infoupdate);
        }}
      >
        <div className="row">
          <div className="col-12 col-md-6 col-lg-3 col-xxl-3 mt-4">
            <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-535353">
              Nivel de educación
            </span>
            <Form.Item
              className="no-margin"
              name="nivel_educacion"
              rules={[{ required: true, message: "Campo obligatorio" }]}
            >
              <Select placeholder="Seleccionar...">
                <Select.Option value="Técnica">Técnica</Select.Option>
                <Select.Option value="Tecnología">Tecnología</Select.Option>
                <Select.Option value="Profesional">Profesional</Select.Option>
                <Select.Option value="Especialización">Especialización</Select.Option>
                <Select.Option value="Maestría">Maestría</Select.Option>
              </Select>
            </Form.Item>
          </div>
          <div className="col-12 col-md-6 col-lg-3 col-xxl-3 mt-4">
            <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-535353">
              Título
            </span>
            <Form.Item
              className="no-margin"
              name="titulo"
              rules={[{ required: true, message: "Campo obligatorio" }]}
            >
              <Input maxLength={80} />
            </Form.Item>
          </div>
          <div className="col-12 col-md-6 col-lg-3 col-xxl-3 mt-4">
            <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-535353">
              Institución educativa
            </span>
            <Form.Item
              className="no-margin"
              name="institucion_educativa"
              rules={[{ required: true, message: "Campo obligatorio" }]}
            >
              <Input maxLength={100} />
            </Form.Item>
          </div>
          <div className="col-12 col-md-6 col-lg-3 col-xxl-3 mt-4">
            <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-535353">
              Ciudad
            </span>
            <Form.Item
              className="no-margin"
              name="ciudad"
              rules={[{ required: true, message: "Campo obligatorio" }]}
            >
              {/* <Input /> */}
              <InputTexto
                name="ciudad"
                texto={educacionFormal.ciudad}
                setTexto={setEducacionFormal}
                alltexto={educacionFormal}
                maxLength={80}
              />
            </Form.Item>
          </div>
          <div className="col-12 col-md-6 col-lg-3 col-xxl-3 mt-4">
            <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-535353">
              ¿Graduado?
            </span>
            <Form.Item
              className="no-margin"
              name="graduado"
              rules={[{ required: true, message: "" }]}
            >
              <Radio.Group onChange={handleGraduacion}>
                <Radio key="graduado-si" value={true}>
                  Sí
                </Radio>
                <Radio key="graduado-no" value={false}>
                  No
                </Radio>
              </Radio.Group>
            </Form.Item>
          </div>
          {isGraduado ? (
            <>
              <div className="col-12 col-md-6 col-lg-3 col-xxl-3 mt-4">
                <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-535353">
                  Fecha de graduación
                </span>
                <Form.Item
                  className="no-margin"
                  name="fecha_graduacion"
                  rules={[{ required: true, message: "Campo obligatorio" }]}
                >
                  <DateInput
                    save={(fecha) => {
                      setEducacionFormal({
                        ...educacionFormal,
                        fecha_graduacion: fecha,
                      });
                    }}
                    dia={educacionFormal?.fecha_graduacion?.split("-")[2] || ""}
                    mes={educacionFormal?.fecha_graduacion?.split("-")[1] || ""}
                    anio={
                      educacionFormal?.fecha_graduacion?.split("-")[0] || ""
                    }
                  />
                </Form.Item>
              </div>

              <div className="col-12 col-md-6 col-lg-6 col-xxl-6 mt-4">
                <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-535353">
                  Diploma o certificado
                </span>
                <Form.Item
                  className="no-margin"
                  name="path_anexo"
                  rules={[{ required: true, message: "Documento obligatorio" }]}
                >
                  <DocumentInput
                    doc={educacionFormal.path_anexo}
                    fileInputRef={fileInputRef}
                    ancho_btn={30}
                    on_change={(e) => {
                      guardarArchivo(e);
                      e.target.value = "";
                    }}
                    onDelete={() => {
                      setEducacionFormal({
                        ...educacionFormal,
                        path_anexo: "",
                      });
                    }}
                  />
                </Form.Item>
              </div>
            </>
          ) : (
            <div className="col-12 col-md-6 col-lg-6 col-xxl-6 mt-4">
              <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-535353">
                Certificados de estudios
              </span>
              <Form.Item
                className="no-margin"
                name="path_anexo"
                rules={[{ required: true, message: "Documento obligatorio" }]}
              >
                <DocumentInput
                  doc={educacionFormal.path_anexo}
                  fileInputRef={fileInputRef}
                  ancho_btn={30}
                  on_change={(e) => {
                    guardarArchivo(e);
                    e.target.value = "";
                  }}
                  onDelete={() => {
                    setEducacionFormal({
                      ...educacionFormal,
                      path_anexo: "",
                    });
                  }}
                />
              </Form.Item>
            </div>
          )}
        </div>
        <div className="d-flex justify-content-end align-content-center">
          <div className="d-flex justify-content-end  align-content-center">
            <Button
              className="button-azul-ghost"
              style={{ marginTop: "20px" }}
              onClick={resetForm}
            >
              Limpiar Campos
            </Button>
          </div>
          <div className="d-flex justify-content-end  align-content-center">
            <Button
              className="button-blanco-radius"
              form="educacionFormalForm"
              htmlType="submit"
            >
              Agregar
            </Button>
          </div>
        </div>
      </Form>
  );
};
